import AWS from "aws-sdk";

const bucket = process.env.REACT_APP_CLOUDFLARE_BUCKET_NAME;
const secretKey = process.env.REACT_APP_CLOUDFLARE_SECRET_KEY;
const accessKey = process.env.REACT_APP_CLOUDFLARE_ACCESS_KEY;
const accountId = process.env.REACT_APP_CLOUDFLARE_ACCOUNT_ID;

export const uploadFileToR2 = (file, bucketPath) => {
  const s3 = new AWS.S3({
    accessKeyId: accessKey,
    secretAccessKey: secretKey,
    endpoint: new AWS.Endpoint(`https://${accountId}.r2.cloudflarestorage.com`),
    region: "auto",
    signatureVersion: "v4",
  });

  const params = {
    Bucket: bucket,
    Key: bucketPath,
    Body: file,
    ContentType: file.type,
    ContentDisposition: "inline",
  };

  return s3
    .putObject(params)
    .on("httpUploadProgress", () => {
      // optional: track progress
    })
    .promise();
};

export const deleteFileFromR2 = (bucketPath) => {
  const s3 = new AWS.S3({
    accessKeyId: accessKey,
    secretAccessKey: secretKey,
    endpoint: new AWS.Endpoint(`https://${accountId}.r2.cloudflarestorage.com`),
    region: "auto",
    signatureVersion: "v4",
  });

  const params = {
    Bucket: bucket,
    Key: bucketPath, // Same path you used when uploading
  };

  return s3.deleteObject(params).promise();
};

export const debounce = (func, timeOut = 400) => {
  let timer;
  return (...args) => {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, timeOut);
  };
};
